import { CommunicationLibraryAssets } from './types/communication-library.types';
import leafIcon from './assets/energy_savings_leaf.svg';
import backgrayIcon from './assets/cp_back_icon.svg';
import downIcon from './assets/Chevron_Down.svg';
import upIcon from './assets/Chevron_Up.svg';
import successIcon from './assets/success.svg';
import failureIcon from './assets/failure.svg';

export const COMMUNICATION_LIBRARY_ASSETS: CommunicationLibraryAssets = {
  LEAF_ICON: leafIcon,
  BACK_GRAY_ICON: backgrayIcon,
  DOWN_ICON: downIcon,
  UP_ICON: upIcon,
  SUCCESS_ICON: successIcon,
  FAILURE_ICON: failureIcon,
};
